import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Portfolio from "../views/Portfolio.vue";
import Resume from "../views/Resume.vue";
import Services from "../views/Services.vue";
import Contact from "../views/Contact.vue";
// import ViewPortfolio from "../components/portfolio-detail.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/portfolio",
    name: "Portfolio",
    component: Portfolio
  },
  {
    path: "/resume",
    name: "Resume",
    component: Resume
  },
  {
    path: "/services",
    name: "Services",
    component: Services
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },
  // {
  //   path: "/view-portfolio",
  //   name: "ViewPortfolio",
  //   component: ViewPortfolio
  // },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
